import { render, staticRenderFns } from "./landing-layout.vue?vue&type=template&id=3661ee80&scoped=true&"
import script from "./landing-layout.vue?vue&type=script&lang=js&"
export * from "./landing-layout.vue?vue&type=script&lang=js&"
import style0 from "./landing-layout.vue?vue&type=style&index=0&id=3661ee80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3661ee80",
  null
  
)

export default component.exports